import React from 'react'
import { Row, Col, Image } from 'react-bootstrap'
import Imagen from '../../images/aviso.jpg'

const Aviso = () => {
    return (

                <Row noGutters>
                    <Col>
                    <Image src={Imagen} fluid/>
                    </Col>
                </Row>

    )
}

export default Aviso
